<div style="text-align: right;">
    <i class="material-icons __close-button" (click)="onNoClick()" matTooltip="Close Popup">close</i>
  </div>
<div style="display: flex; flex-direction: row; justify-content: space-between;">
  <div style="display: flex; flex-direction: column;">
    <label style="text-align: center; flex-flow: wrap;width: 100px" >{{photo1_name}}</label>
    <img  *ngIf="photo1!=null && !IsImageUrl" class="photo-container__photo" [src]="sanitize(photo1, sanitizeImage)"  style="width: 100px;" (click)="LoadselectedImage(photo1,photo1_name,photoId1)" />
    <img  *ngIf="photo1!=null && IsImageUrl" class="photo-container__photo" [src]="sanitize(photo1, sanitizeImage)"  style="width: 100px;" (click)="LoadselectedImage(photo1,photo1_name,photoId1)" />
    <label *ngIf="photo1==null && this.comingFrom==5" style="cursor: pointer;">
      <span style="font-size: 80px;" class="material-icons"> wallpaper</span>
      <input style="display: none;"  type="file" accept="image/*" (change)="replacePhotoClicked($event,1)">
    </label>
  </div>

  <div style="display: flex; flex-direction: column;">
    <label style="text-align: center;flex-flow: wrap;width: 100px">{{photo2_name}}</label>
    <img *ngIf="photo2!=null && !IsImageUrl" class="photo-container__photo" [src]="sanitize(photo2, sanitizeImage)"  style="width: 100px;" (click)="LoadselectedImage(photo2,photo2_name,photoId2)" />
    <img *ngIf="photo2!=null && IsImageUrl" class="photo-container__photo" [src]="sanitize(photo2, sanitizeImage)"  style="width: 100px;" (click)="LoadselectedImage(photo2,photo2_name,photoId2)" />
    <label *ngIf="photo2==null && this.comingFrom!=5" style="cursor: pointer;">
      <span style="font-size: 80px;" class="material-icons"> wallpaper</span>
      <input style="display: none;" type="file" 
         accept="image/*"
         (change)="replacePhotoClicked($event,2)">
    </label>
  </div>

  <div style="display: flex; flex-direction: column;">
    <label style="text-align: center;flex-flow: wrap;width: 100px">{{photo3_name}}</label>
    <img  *ngIf="photo3!=null && !IsImageUrl"class="photo-container__photo" [src]="sanitize(photo3, sanitizeImage)"  style="width: 100px;" (click)="LoadselectedImage(photo3,photo3_name,photoId3)" />
    <img  *ngIf="photo3!=null && IsImageUrl"class="photo-container__photo" [src]="sanitize(photo3, sanitizeImage)"  style="width: 100px;" (click)="LoadselectedImage(photo3,photo3_name,photoId3)" />
    <label *ngIf="photo3==null && this.comingFrom!=5"  style="cursor: pointer;">
      <span style="font-size: 80px;"  class="material-icons"> wallpaper</span>
      <input style="display: none;" type="file"
         accept="image/*"
         (change)="replacePhotoClicked($event,3)">
    </label>
  </div>

  <div style="display: flex; flex-direction: column;">
    <label style="text-align: center; flex-flow: wrap;width: 100px">{{photo4_name}}</label>
    <img *ngIf="photo4!=null && !IsImageUrl" class="photo-container__photo" [src]="sanitize(photo4, sanitizeImage)"   style="width: 100px;" (click)="LoadselectedImage(photo4,photo4_name,photoId4)" />
    <img *ngIf="photo4!=null && IsImageUrl" class="photo-container__photo" [src]="sanitize(photo4, sanitizeImage)"   style="width: 100px;" (click)="LoadselectedImage(photo4,photo4_name,photoId4)" />
    <label *ngIf="photo4==null && this.comingFrom!=5"  style="cursor: pointer;">
      <span style="font-size: 80px;" class="material-icons"> wallpaper</span>
      <input style="display: none;" type="file"
         accept="image/*"
         (change)="replacePhotoClicked($event,4)">
    </label>
  </div>

  <div style="display: flex; flex-direction: column;">
    <label style="text-align: center; flex-flow: wrap;width: 100px">{{photo5_name}}</label>
    <img *ngIf="photo5!=null && !IsImageUrl"  class="photo-container__photo" [src]="sanitize(photo5, sanitizeImage)" style="width: 100px;" (click)="LoadselectedImage(photo5,photo5_name,photoId5)" />
    <img *ngIf="photo5!=null && IsImageUrl"  class="photo-container__photo" [src]="sanitize(photo5, sanitizeImage)" style="width: 100px;" (click)="LoadselectedImage(photo5,photo5_name,photoId5)" />
    <label *ngIf="photo5==null && this.comingFrom!=5" style="cursor: pointer;">
      <span style="font-size: 80px;" class="material-icons"> wallpaper</span>
      <input style="display: none;" type="file"
        accept="image/*"
         (change)="replacePhotoClicked($event,5)">
    </label>
  </div>
</div>

<div class="button-container" *ngIf="isedit">
  <button mat-raised-button class="button" (click)="editPhoto()" *ngIf="isInspector && !IsEditAddInspection"><i class="material-icons button__icon">edit</i><span>{{'Edit' | translate | async}}</span></button>
  <label mat-raised-button class="button replace-photo-btn" *ngIf="isInspector && comingFrom!=5" (click)="fileInput?.click()" style="cursor:pointer; margin-right: 8px;">
    <i class="material-icons button__icon">cloud_upload</i>
    <span class="font">{{ 'Replace Photo' | translate | async }}</span>
     <input  #fileInput  *ngIf="comingFrom!=5" type="file"  accept="image/*" (change)="replacePhotoClicked($event,0)" hidden>
  </label>
 
  <!-- TT-9006 Remove the condition as suggest by sean so that delete button will appear on wsre edit image screen -->
  <!-- <button  mat-raised-button class="button" (click)="deletePhoto()" *ngIf="isInspector && !isWsreFrameObsImage"><i class="material-icons button__icon">delete</i><span>{{'Delete' | translate | async}}</span></button> -->
  <button  mat-raised-button class="button" (click)="deletePhoto()" *ngIf="isInspector"><i class="material-icons button__icon">delete</i><span>{{'Delete' | translate | async}}</span></button>
  <input *ngIf="!isWsreFrameObsImage" type="text" [(ngModel)]="imageTitle" style="width: 50%;height: 35px;" (focusout)="UpdateTitle()">
</div>
<div class="photo-container">
  <div class="photo-scroll">
    <img class="photo-container__photo" [src]="sanitize(photo, sanitizeImage)" *ngIf="!photoLoading" (click)="openLargeImage(photo)"/>
  </div>
  <div class="center" *ngIf="photoLoading">
    <mat-spinner></mat-spinner>
  </div>
</div>
<!-- <input style="display: none;" type="file"
        accept="image/*"
       (change)="replacePhotoClicked($event,0)"> -->
